import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../../_models/user';
import { Router } from '@angular/router';
import { MensajeService } from './mensaje.service';
import { SpinnerService } from 'src/app/spinner.service';
import { ConsumeCredencialesService } from '../servicio/consume-credenciales.service';
@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {

  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private URL_REST = environment.url_api;
  private user : User;

  constructor(
              private router: Router,
              private msjserv : MensajeService,
              private spin : SpinnerService,
              private cred_serv : ConsumeCredencialesService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();  
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public login(username, password) {
    
    let recurso = 'login';
    let app = 1;

    this.cred_serv
        .post(recurso, {username, password, app})
        .subscribe((data: any=[])=>{
            
            this.spin.spin$.next(false);
            if( data.token) {

            this.user = new User();
            this.user.firstName = data.firstName;
            this.user.lastName = data.lastName;
            this.user.username = data.username;
            this.user.token = data.token;
            this.user.id_usuario = data.id_usuario;
            this.user.menu = data.menu;
            this.user.actions = data.actions;

            localStorage.setItem('currentUser', JSON.stringify(this.user));
            this.currentUserSubject.next(this.user);
            
            if(this.tiene_menu()){
              this.router
                  .navigate([environment.home])
                  .then(()=>{
                    window.location.reload(); 
                  });
            }

            }else{
              //Se hace el llamado al dialog generico a mostrar
              this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_ERROR);
            }
          });
  }

  public logout(){
    this.cred_serv.post('logout',{})
        .subscribe(
          (data : any)=>{

            this.spin.spin$.next(false);
            this.msjserv.ver_mensaje(data.msg, '', this.msjserv.TIPO_OK)
                        .afterClosed().subscribe(
                          ()=>{
                            this.eliminar_sesion();
                            this.router
                                .navigate([environment.login])
                                .then(()=>{
                                  window.location.reload(); 
                                });
                          }
                        );

          }
        )
  }

  public eliminar_sesion(){

    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);

  }

  public recuperar_contrasena(data_form){

    this.cred_serv.post('generaTokenContrasena',data_form)
        .subscribe(
          (data:any)=>{
            this.spin.spin$.next(false);

            let tipo_mensaje = this.msjserv.TIPO_OK;

            if (data.code > 0){
              tipo_mensaje = this.msjserv.TIPO_ERROR
            }

            this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje)
                .afterClosed()
                .subscribe(
                  ()=>{
                    if (data.code == 0){
                      this.router
                                .navigate([environment.login])
                                .then(()=>{
                                  window.location.reload(); 
                                });
                    }
                  }
                );
          }
        )

  }

  /**
   * Valida si el usuario tiene un menu
   */
  public tiene_menu(){

    let retorno = true;
    
    if (!this.currentUserValue.menu || this.currentUserValue.menu.length ==0){
      retorno = false;
      this.msjserv.ver_mensaje('El usuario no tiene un menu disponible', '', this.msjserv.TIPO_ERROR)
          .afterClosed()
          .subscribe(
            ()=>{
              this.logout();
            }
          );

    }

    return retorno;
  }
}
